import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../apiClient";

export const putCalendar = ({ id, ...data }) => {
  return api.put(`/admin/calendar/${id}`, data);
};

export const usePutCalendarMutation = ({ mutationConfig } = {}) => {
  const queryClient = useQueryClient();

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    mutationFn: putCalendar,
    onSuccess: async (data, ...args) => {
      if (onSuccess) {
        await onSuccess(data, ...args);
      }
      queryClient.invalidateQueries({ queryKey: ["calendars"] });
      queryClient.invalidateQueries({ queryKey: ["calendar"] });
      queryClient.invalidateQueries({ queryKey: ["calendar-date-range"] });
    },
    ...restConfig,
  });
}; 